var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenqiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 371.55,
    height: 371.04,
    viewBox: "0 0 371.55 371.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.93,296.45h-.37A110.83,110.83,0,1,1,183.33,74.8h2.1A110.77,110.77,0,0,1,290.57,220.7l49.81,66.88C396.75,202,373.11,87,287.58,30.63S87-2.1,30.63,83.43-2.1,284,83.44,340.38a185.44,185.44,0,0,0,153.38,23.37c-1.92-2-50.88-67.35-50.88-67.35",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.49,238.86h0l-2.27-3.05c-.56-.71-1.29-1.54-2.07-2.43a75.83,75.83,0,0,0-5.67-5.67c-.88-.79-1.83-1.61-2.82-2.42-.51-.42-1-.84-1.57-1.26l-1.62-1.24q-1.68-1.24-3.56-2.49c-14.69-9.6-30.46-14.3-49.47-14.3H156s79.79,106.79,99.51,133.67A65.48,65.48,0,0,0,263,348.3c.35.34.72.69,1.1,1,.88.79,1.82,1.61,2.82,2.44l1.56,1.26,1.62,1.23c1.13.83,2.31,1.66,3.56,2.49,14.7,9.61,31.2,14.32,49.48,14.32h48.41Z",
    transform: "translate(0 0)",
    fill: "#00b2ec"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenqiLogo);
export default __webpack_public_path__ + "static/media/benqi-logo.94aa31b962e04f445a0cc4c97eea226a.svg";
export { ForwardRef as ReactComponent };